import React from 'react';

const classLabel = (classItem) =>
  [classItem.matricula_clase, classItem.nombre_clase]
    .filter(Boolean)
    .join(' - ') || `Clase ${classItem.id_clase}`;

const studentLabel = (student) =>
  student.matricula_alumno
    ? `${student.nombre_alumno} (${student.matricula_alumno})`
    : student.nombre_alumno;

export const CertificateClassStep = ({
  classes = [],
  students = [],
  idClass,
  mode,
  idStudent,
  onClassChange,
  onModeChange,
  onStudentChange,
  loadingClasses = false,
  loadingStudents = false,
}) => (
  <section
    className="certificate-wizard-card"
    aria-labelledby="certificate-class-step-title"
  >
    <div className="certificate-wizard-card-heading">
      <span aria-hidden="true">1</span>
      <div>
        <h2 id="certificate-class-step-title">Clase y destinatarios</h2>
        <p>Elige primero la clase y después el alcance de la emisión.</p>
      </div>
    </div>

    <div className="certificate-wizard-field">
      <label htmlFor="certificate-wizard-class">Clase</label>
      <select
        id="certificate-wizard-class"
        value={idClass}
        onChange={(event) => onClassChange(event.target.value)}
        disabled={loadingClasses}
        required
      >
        <option value="">
          {loadingClasses ? 'Cargando clases...' : 'Selecciona una clase'}
        </option>
        {classes.map((classItem) => (
          <option key={classItem.id_clase} value={String(classItem.id_clase)}>
            {classLabel(classItem)}
          </option>
        ))}
      </select>
    </div>

    <fieldset className="certificate-wizard-mode">
      <legend>Tipo de emisión</legend>
      <label>
        <input
          type="radio"
          name="certificate-emission-mode"
          value="individual"
          aria-label="Una persona"
          checked={mode === 'individual'}
          onChange={(event) => onModeChange(event.target.value)}
        />
        <span>
          <strong>Una persona</strong>
          <small>Genera la constancia para un alumno inscrito.</small>
        </span>
      </label>
      <label>
        <input
          type="radio"
          name="certificate-emission-mode"
          value="masiva"
          aria-label="Toda la clase"
          checked={mode === 'masiva'}
          onChange={(event) => onModeChange(event.target.value)}
        />
        <span>
          <strong>Toda la clase</strong>
          <small>Usa el listado completo de alumnos inscritos.</small>
        </span>
      </label>
    </fieldset>

    {mode === 'individual' ? (
      <div className="certificate-wizard-field">
        <label htmlFor="certificate-wizard-student">Alumno</label>
        <select
          id="certificate-wizard-student"
          value={idStudent}
          onChange={(event) => onStudentChange(event.target.value)}
          disabled={!idClass || loadingStudents}
          required
        >
          <option value="">
            {loadingStudents ? 'Cargando alumnos...' : 'Selecciona un alumno'}
          </option>
          {students.map((student) => (
            <option key={student.id_alumno} value={String(student.id_alumno)}>
              {studentLabel(student)}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <p className="certificate-wizard-note">
        Se incluirán todos los alumnos inscritos.
      </p>
    )}
  </section>
);
